import { getAllCountries } from '../services/ApiService';
  const fetchAllCountries=()=>{
    return async(dispatch:any)=>{
        const countries = await getAllCountries();
        dispatch({
            type: "fetch_all_countries",
            payload:countries,
        })
   }
}
 export default fetchAllCountries;